import {Theme} from '@mui/material';
import {formatText} from 'presentation/utils';
import {translations} from 'presentation/translations-new';
import {AuthorizationOdontoStatusEnum} from './authorizationOdontoStatus';
import {OdontoStatus, CardStyleByStatusType, CardStyleFunction} from './types';

const {status: statusCard} = translations['pt-br'].privateFlow.requestAuthorizations;

export const cardStyleByOdontoStatus: CardStyleFunction = (theme: Theme, status: OdontoStatus) => {
	const styles: CardStyleByStatusType = {
		[AuthorizationOdontoStatusEnum.FINISHED]: {
			borderColor: theme.palette.success.main,
			chipVariant: 'success',
			chipText: statusCard.finished,
		},
		[AuthorizationOdontoStatusEnum.UNDER_ANALYSIS]: {
			borderColor: theme.palette.primary.light,
			chipVariant: 'primary',
			chipText: statusCard.underOdontoAnalysis,
		},
		[AuthorizationOdontoStatusEnum.PENDING]: {
			borderColor: theme.palette.warning.main,
			chipVariant: 'warning',
			chipText: statusCard.pendingItems,
		},
		[AuthorizationOdontoStatusEnum.CANCELED]: {
			borderColor: theme.palette.error.main,
			chipVariant: 'error',
			chipText: statusCard.canceled,
		},
		[AuthorizationOdontoStatusEnum.REJECTED]: {
			borderColor: theme.palette.error.main,
			chipVariant: 'error',
			chipText: statusCard.rejected,
		},
	};

	const defaultStyles = {
		borderColor: theme.palette.text.disabled,
		chipVariant: 'default' as const,
		chipText: formatText(status),
	};

	return styles[status] ?? defaultStyles;
};
